<template>
  <!-- v-if="vx_billModal.hasOwnProperty('billInfo')" -->
  <div class="bill-item text_hailing">
    <div class="row">
      <div class="col-md-6 col-sm-6">
        <span class="title-color">單號：</span>
        <span>
          {{ vx_billModal.id }}
        </span>
      </div>
      <div class="col-md-6 col-sm-6">
        <span class="title-color">接單時間：</span>
        <span>{{ driverGrabOrderDateFormat }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-6">
        <span class="title-color">派單客服：</span>
        <span>{{ vx_billModal.managerName }}</span>
      </div>
      <div class="col-md-6 col-sm-6">
        <span>目前狀態：{{ vx_billModal.orderStatus }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-6">
        <span>原本預計到達時間：</span>
        <span>{{ processEstimatedTime() }} 分</span>
      </div>
      <!--TODO: check-->
      <div class="col-md-6 col-sm-6" v-if="isRefreshTime">
        <span style="color: red">最新到達時間：</span>
        <span style="color: red">{{ time }}</span>
        <button class="btn-primary btn position fontSize14" @click="calTime">
          更新時間
        </button>
      </div>
    </div>
    <div class="row" v-if="vx_billModal.cancelReason !== ''">
      <div class="col-md-6 col-sm-6" />
      <div class="col-md-6 col-sm-6">
        <span style="color: red">取消原因：</span>
        <span style="color: red">
          {{ vx_billModal.cancelReason }}
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-6">
        <span class="title-color">發單時間：</span>
        <span>{{ orderCreatedDateFormat }}</span>
      </div>
      <div class="col-md-6 col-sm-6" v-if="vx_billModal.cancelReason !== ''">
        <span>取消客服：</span>
        <span>{{ vx_billModal.doCancelManagerName }}</span>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-md-6 col-sm-6">
        <span class="style-color">司機名字:</span>
        <span>{{ vx_billModal.driverName }}</span>
      </div>
      <div class="col-md-6 col-sm-6">
        <span class="title-color">司機隊編/呼號：</span>
        <span style="color: red">{{ vx_billModal.driverCallNumber }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-6">
        <span class="title-color">司機電話：</span>
        <span>{{ vx_billModal.driverPhoneNumber }}</span>
      </div>
      <div class="col-md-6 col-sm-6">
        <span class="title-color">派遣方式：</span>
        <span>{{ vx_billModal.strategyName }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-6">
        <span class="title-color">排班站：</span>
        <span>{{ vx_billModal.scheduledStation }}</span>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-md-6 col-sm-6">
        <span class="title-color">乘客電話：</span>
        <span>{{ vx_billModal.passengerPhoneNumber }}</span>
      </div>
      <div class="col-md-6 col-sm-6">
        <span class="title-color">乘客備註：</span>
        <span>{{ vx_billModal.passengerNote }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-6">
        <span class="title-color">服務項目：</span>
        <!-- <span>{{ serviceNameList }}</span> -->
        <span>
          {{
            vx_billModal.serviceList == ''
              ? '無篩選服務'
              : vx_billModal.serviceList
          }}
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <span class="title-color">上車地點：</span>
        <span>{{ vx_billModal.onLocation }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-sm-6">
        <span class="title-color">下車地點：</span>
        <span>{{ vx_billModal.offLocation }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-sm-6">
        <span class="title-color">下車地點(實際下車位置)：</span>
        <span>
          {{
            vx_billModal.actualOffLocation === ''
              ? '無實際下車地點'
              : vx_billModal.actualOffLocation
          }}
        </span>
      </div>
    </div>
    <br />
    <div class="row" v-show="isAfterCancel">
      <div class="col-md-5 col-sm-5">
        <el-select
          v-model="passengerCancelMsg"
          placeholder="請選擇"
          @change="cancelNoteOnChange"
        >
          <el-option
            v-for="msg in cancelMsg"
            :key="msg.value"
            :label="msg.label"
            :value="msg.value"
          />
        </el-select>
      </div>
      <div class="col-md-4 col-sm-4">
        <textarea
          type="text"
          required="required"
          class="inputstyle col-md-12 fontSize14"
          placeholder="備註"
          row="1"
          v-model="passengerCancelNote"
          maxlength="60"
        />
      </div>
      <el-button type="danger" @click="onCancelOrder">
        中心取消乘客叫車
      </el-button>
    </div>
    <hr />
    <div class="row" v-show="isSendMsgToDriver">
      <div class="col-md-5 col-sm-5">
        <el-select v-model="message" placeholder="請選擇">
          <el-option
            v-for="item in defaultMsgList"
            :key="item.value"
            :label="item.label"
            :value="item.label"
          />
        </el-select>
      </div>
      <div class="col-md-4 col-sm-4">
        <textarea
          type="text"
          required="required"
          class="inputstyle col-md-12 fontSize14"
          placeholder="即時訊息"
          row="3"
          v-model="message"
          maxlength="60"
        />
      </div>
      <el-button type="primary" @click="onSendMsg">傳送訊息</el-button>
      <el-checkbox v-model="isRequireDriverResponse" style="margin-top: 1rem">
        請司機回覆「是」「否」
      </el-checkbox>
    </div>
    <hr v-show="isSendMsgToDriver" />
    <!--modal中下方呈現司機資訊的表格-->
    <table class="table table-striped jambo_table bulk_action">
      <!-- <thead>
        <tr class="headings">
          <th v-for="head in HEAD" :key="head" class="column-title word_center">
            {{ head }}
          </th>
        </tr>
      </thead> -->
      <thead>
        <tr class="headings">
          <th v-for="head in HEAD" :key="head" class="column-title word_center">
            <el-tooltip
              v-if="head === '距離(公尺)'"
              content="搶單當下與乘客的距離"
              placement="top-start"
              class="tool-tip"
            >
              <div>{{ head }}</div>
            </el-tooltip>
            <div v-else>{{ head }}</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="driver in vx_billModal.allGrabOrderStateData">
          <tr class="pointer" :key="driver.sortIndex">
            <td class="word_center">{{ driver.sortIndex }}</td>
            <td class="word_center">{{ driver.driverCallNumber }}</td>
            <td class="word_center">{{ driver.driverName }}</td>
            <td class="word_center">{{ driver.driverPhoneNumber }}</td>
            <td class="word_center">{{ driver.driverNote }}</td>
            <td class="word_center">{{ driver.distance }}</td>
            <td class="word_center">
              {{ driver.carState }}
            </td>
            <td class="word_center">
              {{ driver.driverState }}
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import {
  reqCancelOrder,
  /* reqDriverCancel, */
  reqPushMsg,
  reqDriverStatusList,
} from '@/api/hailState'
import { reqUpdateArriveTime } from '@/api/transaction'
import dayjs from 'dayjs'
import { cookies } from '@/utils/cookies'
import { mapState, mapActions } from 'vuex'
import { detail } from '@/constants/tableHead'
/* import { carStatus } from '@/constants/car' */
/* import { driverRes } from '@/constants/driver' */
import { cancelMsg } from '@/constants/msg'
import { Notification } from 'element-ui'
import Record_behavir from '@/assets/js/libs/FirebaseAPI/RecordBill'
import Message from '@/assets/js/libs/Message'
const message = new Message()
const record = new Record_behavir()

export default {
  props: ['defaultMsgList'],
  data() {
    return {
      isAfterCancel: false,
      /* notifyPassengerDriverCancel: false, */
      passengerCancelMsg: '',
      passengerCancelNote: '',
      driverCancelArray: [],
      driverList: [] /*HACK: might be useless*/,
      cancelMsg: [],
      // msg
      isSendMsgToDriver: true,
      isRequireDriverResponse: false,
      message: '',
      service: null,
      isRefreshTime: true,
      time: '---',
    }
  },
  methods: {
    ...mapActions('hailStateV2', {
      vx_fetchBillList: 'fetchBillList',
      vx_refreshModalInfo: 'refreshModalInfo',
    }),
    cancelNoteOnChange(cancelNoteVal) {
      this.cancelMsg.forEach(({ value, label }) => {
        if (value === cancelNoteVal) {
          this.passengerCancelNote = label
        }
      })
    },
    /*HACK: might be useless*/
    async fetchDriverList(id) {
      try {
        const { result } = await reqDriverStatusList(id)
        this.driverList = result
      } catch (e) {
        console.error(e)
      }
    },
    /* 取消叫車 */
    async onCancelOrder() {
      if (this.passengerCancelNote === '') return this.$msg('請輸入取消原因')
      try {
        const { result } = await reqCancelOrder({
          token: cookies.get('user'),
          action: 'after',
          passenMessage: this.passengerCancelNote,
          orderId: this.vx_billModal.id,
        })
        if (result === '已取消叫車') {
          record.postRecord({
            type: '立即單',
            event: '回傳取消',
            code: cookies.get('GladTeamCode'),
            user_name: cookies.get('GladName'),
            id: this.vx_billModal.id,
            note: '叫車紀錄取消',
            user_id: '',
          })
          this.vx_fetchBillList()
          this.vx_refreshModalInfo()
          await reqPushMsg(this.vx_billModal.id)
          Notification({
            title: '已成功取消叫車',
            type: 'success',
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    /* 發送訊息給司機 */
    async onSendMsg() {
      try {
        const res = await message.pushDriverMessage(
          {
            announcer: cookies.get('GladName'),
            teamCode: this.vx_billModal.driverTeamCode,
            callNumber: this.vx_billModal.driverCallNumber,
            content: this.message,
            require_driver_response: this.isRequireDriverResponse,
            reference: '叫車紀錄',
          },
          'one',
        )
        record.postRecord({
          type: '立即單',
          event: '傳訊息',
          code: cookies.get('GladTeamCode'),
          user_name: cookies.get('GladName'),
          id: this.vx_billModal.id,
          note: '傳訊息' + this.message,
          user_id: '',
        })
        if (res.success) {
          Notification({
            title: `傳送訊息成功`,
            type: 'success',
          })
          this.message = ''
        } else {
          Notification({
            title: `傳送失敗，有可能呼號錯誤`,
            type: 'error',
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    async calTime() {
      try {
        const { result } = await reqUpdateArriveTime(this.vx_billModal.id)
        this.time = result.duration
      } catch (e) {
        console.error(e)
      }
    },
    /* 在parent component中執行 */
    initUpdate() {
      this.isAfterCancel = false
      if (
        this.vx_billModal.hasOwnProperty('cancelReason') &&
        this.vx_billModal.cancelReason !== ''
      ) {
        this.driverCancelArray = this.vx_billModal.cancelReason.split(',')
      } else {
        this.driverCancelArray = []
      }
      /* block2 */
      if (!this.vx_billModal.finishTime) {
        if (this.vx_billModal.getPassengerTime) {
          /* 載到乘客的時間, 沒完成時間 */
          this.isRefreshTime = false
        } else {
          /* 沒完成, 沒乘客上車 */
          this.isAfterCancel = true
        }
        this.isSendMsgToDriver = true
        return
      }
      /* block3 */
      if (this.vx_billModal.cancelReason !== '') {
        this.isSendMsgToDriver = false
        this.isRefreshTime = false
        return
      }
      /* block4 */
      if (this.vx_billModal.cancelReason !== '') {
        if (this.driverCancelArray.length === 1) {
          this.isSendMsgToDriver = false
          this.isRefreshTime = false
          return
        }
      } else {
        if (
          this.vx_billModal.finishTime &&
          this.vx_billModal.cancelReason === ''
        ) {
          this.isSendMsgToDriver = false
          this.isRefreshTime = false
          return
        }
      }
      /* block5 */
      if (this.driverCancelArray.length === 3) {
        this.isSendMsgToDriver = false
        this.isRefreshTime = false
        return
      }
      /* block6 */
      if (this.vx_driverInfo.driverName === '') {
        this.isSendMsgToDriver = false
        this.isRefreshTime = false
        return
      }
    },
    processEstimatedTime: function () {
      // 判斷是否為後派單，若是則顯示 ---
      if (
        this.vx_billModal.passengerNote &&
        this.vx_billModal.passengerNote.includes('後派單')
      ) {
        return '---'
      }

      // 確保 estimatedTime 是數值
      const time = Number(this.vx_billModal.estimatedTime)
      return isNaN(time) ? '---' : time
    },
  },
  computed: {
    ...mapState('hailStateV2', {
      vx_driverInfo: 'driverInfo',
      vx_billModal: 'billModal',
    }),
    driverGrabOrderDateFormat() {
      return this.vx_billModal.driverGrabOrderDate
        ? dayjs(this.vx_billModal.driverGrabOrderDate).format(
            'YYYY-MM-DD HH:mm:ss',
          )
        : null
    },
    orderCreatedDateFormat() {
      return this.vx_billModal.orderCreatedDate
        ? dayjs(this.vx_billModal.orderCreatedDate).format(
            'YYYY-MM-DD HH:mm:ss',
          )
        : null
    },
  },
  created() {
    this.HEAD = detail
    this.cancelMsg = cancelMsg
    this.unwatch = this.$store.watch(
      (state) => state.hailStateV2.billModal,
      (billModal) => {
        this.fetchDriverList(billModal.id)
        this.initUpdate()
      },
    )
  },
  beforeDestroy() {
    this.unwatch()
  },
}
</script>

<style scoped>
span {
  color: #000;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/hailState/components-v2/BillModal.vue